import React from 'react';
import { NavLink } from 'react-router-dom'

import './NotFound.scss';

export function NotFound() {
	return (
		<div className="container not-found-component">
			<div className="row justify-content-center align-items-center">
				<div className="col text-center">
					<h1>404</h1>
					<h2>We are sorry, but the page you requested was not found</h2>
					<div>
						<NavLink to="/">Documentation home</NavLink>
					</div>
				</div>
			</div>
		</div>
	);
}